
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.5 14a2.5 2.5 0 012.5-2.5h12.438c.227 0 .445.09.606.251l.597.597 1.18 1.253a2.5 2.5 0 01.679 1.714V33a2.5 2.5 0 01-2.5 2.5H18a2.5 2.5 0 01-2.5-2.5V14z","stroke":"#fff"}}),_c('path',{attrs:{"d":"M18 32h13M18 29h13M18 26h13","stroke":"#fff","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M33 16.5h-4a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h1.172a1.5 1.5 0 011.06.44l1.829 1.828a1.5 1.5 0 01.439 1.06V16a.5.5 0 01-.5.5z","stroke":"#fff"}})])
          )
        }
      }
    